import pako from 'pako'
import BaseAPIService from '@/services/baseAPIService'

export default class OrdersAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }
  

  createOrder(data, options = {}) {
    if(options.useCompression) {
      const gzippedBundle = pako.gzip(JSON.stringify(data));

      return this.httpClient.post(`/orders`, gzippedBundle, {
        headers: {
          'Content-Encoding': 'gzip',
          'Content-Type': 'application/json'
        }
      })
    }

    return this.httpClient.post(`/orders`, data)
  }
  getOrder(id)                                { return this.httpClient.get(`/orders/${id}`) }
  updateOrder(id, data)                       { return this.httpClient.put(`/orders/${id}`, data) }
  getOrderFilteredList(options = {}) {
    var params = {
      filter: options.filter || {}
    }
    if(options.order)
      params.order = options.order
    if(options.columns)
      params.columns = options.columns
    if(options.search)
      params.search = options.search
    if(options.startDateOrderCreated)
      params.startDateOrderCreated = options.startDateOrderCreated
    if(options.endDateOrderCreated)
      params.endDateOrderCreated = options.endDateOrderCreated
    if(options.viewType)
      params.viewType = options.viewType
    
    var queryString = '/orders?' + $.param(params)

    return this.httpClient.get(queryString)
  }

  updateOrderItems(id, data, options = {}) {
    if(options.useCompression) {
      const gzippedBundle = pako.gzip(JSON.stringify(data));

      return this.httpClient.put(`/orders/${id}/orderitems`, gzippedBundle, {
        headers: {
          'Content-Encoding': 'gzip',
          'Content-Type': 'application/json'
        }
      })
    }

    return this.httpClient.put(`/orders/${id}/orderitems`, data)
  }

  approveOrder(id, data)                      { return this.httpClient.post(`/orders/${id}/approve`, data) }
  denyOrder(id, data)                         { return this.httpClient.post(`/orders/${id}/deny`, data) }
  recheckApprovals(id)                        { return this.httpClient.post(`/orders/${id}/recheckapprovals`) }
  restoreOrder(id, data)                      { return this.httpClient.post(`/orders/${id}/restore`, data) }

  reviewOrder(data, options = {}) {
    if(options.useCompression) {
      const gzippedBundle = pako.gzip(JSON.stringify(data));

      return this.httpClient.post(`/orders/review`, gzippedBundle, {
        headers: {
          'Content-Encoding': 'gzip',
          'Content-Type': 'application/json'
        }
      })
    }

    return this.httpClient.post(`/orders/review`, data)
  }
  

  skipPendingPayments(id, data)               { return this.httpClient.post(`/orders/${id}/skippendingpayments`, data) }
  forceOrderDespatched(id, data)              { return this.httpClient.post(`/orders/${id}/forceorderdespatched`, data) }
  forceOrderInvoiced(id, data)                { return this.httpClient.post(`/orders/${id}/forceorderinvoiced`, data) }

  getOrderPayments(id)                        { return this.httpClient.get(`/orders/${id}/payments`) }
  createOrderPayment(id, data)                { return this.httpClient.post(`/orders/${id}/payments`, data) }

  getOrderSendOrderTemplate(id, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/orders/${id}/msgtemplates/sendorder?${$.param(params)}`)
  }
  sendOrderEmail(id, data)                    { return this.httpClient.post(`/orders/${id}/sendorder`, data) }

  approveOrderItemNCR(id, orderItemId, data)  { return this.httpClient.post(`/orders/${id}/orderitems/${orderItemId}/approvencr`, data) }
  denyOrderItemNCR(id, orderItemId, data)     { return this.httpClient.post(`/orders/${id}/orderitems/${orderItemId}/denyncr`, data) }

  cancelOrderItem(id, orderItemId, data)      { return this.httpClient.post(`/orders/${id}/orderitems/${orderItemId}/cancel`, data) }

  holdOrder(id, data)                         { return this.httpClient.post(`/orders/${id}/hold`, data) }
  unHoldOrder(id, data)                       { return this.httpClient.post(`/orders/${id}/unhold`, data) }
  cancelOrder(id, data)                       { return this.httpClient.post(`/orders/${id}/cancel`, data) }

  skipChecklistItem(id, data)                 { return this.httpClient.post(`/orders/${id}/checklistitems/skip`, data) }

  // Quotes
  getOrderSendQuoteTemplate(id, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/orders/${id}/msgtemplates/sendquote?${$.param(params)}`)
  }
  sendQuoteEmail(id, data)                    { return this.httpClient.post(`/orders/${id}/sendquote`, data) }
  approveQuote(id)                            { return this.httpClient.post(`/orders/${id}/approvequote`) }
  cancelQuote(id, data)                       { return this.httpClient.post(`/orders/${id}/cancelquote`, data) }
  approveDraft(id)                            { return this.httpClient.post(`/orders/${id}/approvedraft`) }

  // External Purchase Orders
  setupExternalOrderItems(id, data, options = {}) {
    if(options.useCompression) {
      const gzippedBundle = pako.gzip(JSON.stringify(data));

      return this.httpClient.post(`/orders/${id}/externalsetup`, gzippedBundle, {
        headers: {
          'Content-Encoding': 'gzip',
          'Content-Type': 'application/json'
        }
      })
    }

    return this.httpClient.post(`/orders/${id}/externalsetup`, data)
  }
  externalPurchaseOrderSend(id, purchaseOrderId, data)  { return this.httpClient.post(`/orders/${id}/purchaseorders/${purchaseOrderId}/send`, data) }
  getExternalPurchaseOrderTemplate(orderId, supplierContactId, messageTemplateId) {
    var params = { contactId: supplierContactId, messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/orders/${orderId}/msgtemplates/externalpo?${$.param(params)}`)
  }
  recheckExternalPurchaseOrders(id) { return this.httpClient.post(`/orders/${id}/purchaseorders/recheck`) }


  // Stock / Contact Query
  getContactStockLookup(lookupFilter) {
    var params = {
      priceType: lookupFilter.priceType,
     stockId: lookupFilter.stockId,
     contactId: lookupFilter.contactId || 0,
     salesRateId: lookupFilter.defaultSalesRateId || 0,
     stockPriceGroupId: lookupFilter.stockPriceGroupId || 0,
      thickness: lookupFilter.thickness || 0      
    }
      
    return this.httpClient.get(`/orders/orderitems/lookup?${$.param(params)}`)
  }

  // Stock / Contact Batch Query
  getContactStockBatchLookup(lookupList) {
    return this.httpClient.post(`/orders/orderitems/lookupbatch`, { lookupList: lookupList })
  }

  // Orders - Production
  getOrderProductionPanelList(id)             { return this.httpClient.get(`/orders/${id}/panels`) }

  // Orders - Barcode Lookup
  runOrderBarcodeLookup(barcode)              { return this.httpClient.get(`/orders/barcode/lookup?barcode=${encodeURIComponent(barcode)}`) }

  // Orders - Despatch/Production Run List
  orderForceManualScanList(data)             { return this.httpClient.post(`/orders/forceprocessrunlist`, data) }

  // Orders - System Admin Features
  orderForceProductionComplete(id, data)      { return this.httpClient.post(`/orders/${id}/forceproductioncomplete`, data) }
  orderForceSkipPreProduction(id, data)       { return this.httpClient.post(`/orders/${id}/forceskippendingproduction`, data) }
  orderRevertDespatch(id, data)               { return this.httpClient.post(`/orders/${id}/revertdespatch`, data) }
  orderForceRecheckProcessing(id)             { return this.httpClient.post(`/orders/${id}/recheckprocessing`) }
  orderForceRecheckProduction(id)             { return this.httpClient.post(`/orders/${id}/recheckproduction`) }

  // Order - Recovery
  orderUpdateRecovery(data, options = {}) {
    if(options.useCompression) {
      const gzippedBundle = pako.gzip(JSON.stringify(data));

      return this.httpClient.post(`/orders/recovery`, gzippedBundle, {
        headers: {
          'Content-Encoding': 'gzip',
          'Content-Type': 'application/json'
        }
      })
    }

    return this.httpClient.post(`/orders/recovery`, data)
  }
  getOrderRecovery(id)              { return this.httpClient.get(`/orders/recovery/${id}`) }
  orderCancelRecovery(data)         { return this.httpClient.post(`/orders/recovery/cancel`, data) }

  // Orders - Config Settings
  getConfigSettings()               { return this.httpClient.get(`/orders/configuration/settings`) }
  updateConfigSettings(data)        { return this.httpClient.put(`/orders/configuration/settings`, data) }

  getStampConfig()                  { return this.httpClient.get(`/orders/configuration/orderstampconfig`) }
  updateStampConfig(data)           { return this.httpClient.put(`/orders/configuration/orderstampconfig`, data) }

  // Orders - Config - Surcharge
  getOrderSurchargeList()           { return this.httpClient.get(`/orders/configuration/surcharges`) }
  getOrderSurcharge(id)             { return this.httpClient.get(`/orders/configuration/surcharges/${id}`) }
  createOrderSurcharge(data)        { return this.httpClient.post(`/orders/configuration/surcharges`, data) }
  updateOrderSurcharge(id, data)    { return this.httpClient.put(`/orders/configuration/surcharges/${id}`, data) }
  deleteOrderSurcharge(id)          { return this.httpClient.delete(`/orders/configuration/surcharges/${id}`) }

}